module.exports = __webpack_public_path__ + "static/media/BidAlreadySubmitted.2a82c5a5.svg";